import { useFieldArray, Control, useWatch } from 'react-hook-form'
import { Input } from 'src/components/inputs/Input'
import { FormValues } from './types'
import PathwayTaskInput from './PathwayTaskInput'
import { useTranslation } from 'react-i18next'
import { FieldArrayControls } from './FieldArrayControls'
import { useState, useEffect, useRef } from 'react'
import { Collapse } from 'antd'
import './styles.css'

const { Panel } = Collapse

export default function PathwayProgramInput({
  pIdx,
  control,
  coachCategoryOptions,
  taskCategoryOptions,
  taskFrequencyOptions,
}: {
  pIdx: number
  control: Control<FormValues>
  coachCategoryOptions: Record<string, any>[]
  taskCategoryOptions: Record<string, string>[]
  taskFrequencyOptions: Record<string, string>[]
}) {
  const { t } = useTranslation()
  const [activeKeys, setActiveKeys] = useState<string[]>([])
  const programsFieldArray = useFieldArray({
    control,
    name: `pathways.${pIdx}.programs` as const,
  })
  const rowProgramValues = useWatch({
    control,
    name: `pathways.${pIdx}.programs` as const,
  })

  const handlePanelChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys])
  }

  return (
    <>
      <Collapse
        ghost
        activeKey={activeKeys}
        className="site-collapse-custom-collapse"
        onChange={handlePanelChange}
      >
        {programsFieldArray.fields.map((program, prIdx) => {
          const header = (
            <div className="d-flex justify-content-between align-items-center w-100">
              <h5 style={{ fontWeight: 600, color: '#2a3b5d', margin: 0 }}>
                Program {prIdx + 1}
              </h5>
              <div className="col-md-6 col-12 d-flex justify-content-end gap-2">
                <FieldArrayControls
                  fieldArray={programsFieldArray}
                  index={prIdx}
                  onClone={() => {
                    const programToClone = rowProgramValues[prIdx]
                    programsFieldArray.insert(
                      prIdx + 1,
                      JSON.parse(JSON.stringify(programToClone)),
                    )
                  }}
                />
              </div>
            </div>
          )

          return (
            <Panel
              key={program.id}
              className="site-collapse-custom-panel"
              header={header}
            >
              <div className="row mb-2">
                <div className="col-md-6 col-12">
                  <Input
                    required
                    label={t('resource.pathway.field.programTitle')}
                    source={`pathways.${pIdx}.programs.${prIdx}.title`}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    label={t('resource.pathway.field.programDescription')}
                    source={`pathways.${pIdx}.programs.${prIdx}.description`}
                  />
                </div>
              </div>
              <PathwayTaskInput
                coachCategoryOptions={coachCategoryOptions}
                control={control}
                pIdx={pIdx}
                prIdx={prIdx}
                taskCategoryOptions={taskCategoryOptions}
                taskFrequencyOptions={taskFrequencyOptions}
              />
            </Panel>
          )
        })}
      </Collapse>
      <button
        className="btn btn-primary"
        type="button"
        disabled={rowProgramValues.some(
          (program) => !program.title || program.title.trim() === '',
        )}
        onClick={() => {
          programsFieldArray.append({
            title: '',
            description: '',
            tasks: [
              {
                title: '',
                description: '',
                coach_category: '',
                due_date: '',
                task_type: '',
                frequency_unit: 'once',
                frequency_repeats: 1,
              },
            ],
          })
        }}
      >
        Add Program
      </button>
    </>
  )
}
